import {
  dateColumn,
  enumColumn,
  stringColumn,
  booleanColumn,
} from "@sdk-react-ui-atoms/table/columns";
import { MRT_ColumnDef } from "material-react-table";

type ShowData = {
  mstr_Show_ID: number;
  showcode: string;
  showName: string;
  showdate_From: string | number;
  showdate_To: string | number;
  showCountry: string;
  gemS_Country: string;
};

const EmploymentType = {
  FULL_TIME: "FULL_TIME",
  PART_TIME: "PART_TIME",
};

const TableColumns: MRT_ColumnDef<ShowData>[] = [
  stringColumn({
    accessorFn: (row: ShowData) => `${row.mstr_Show_ID} `,
    header: "ID",
    id: "mstr_Show_ID",
  }),
  stringColumn({
    accessorKey: "showcode",
    header: "showcode",
    id: "showcode",
  }),
  stringColumn({
    accessorKey: "showName",
    header: "showName",
    id: "showName",
  }),
  dateColumn({
    accessorFn: (row: ShowData) => new Date(row.showdate_From),
    header: "Start Date",
    id: "showdate_From",
  }),
  dateColumn({
    accessorFn: (row: ShowData) => new Date(row.showdate_To),
    header: "End Date",
    id: "showdate_To",
  }),
];

export default TableColumns;
